import React from "react";
import RackMontanaNFT from "../assets/images/RackMontanaNFT.jpg";
import MrInflationNFT from "../assets/images/MrInflationNFT.jpg";
import {useTranslation} from "react-i18next";
const Exclusives = () => {
  const [ t ] = useTranslation(['home']);
  return (
    <div>
      <div className="container  ">
        <div className="row pt-5">
          <div className="col-12 col-lg-6 mt-5 pt-5">
            <img className="ImgOne" src={RackMontanaNFT} />
            <img className="ImgTwo" src={MrInflationNFT} />
          </div>
          <div className="col-12 col-lg-6  pt-10 exclusive__text-wrap">
            <label className="section-subtitle">
              {t('EXCLUSIVITYINOURPRODUCTS')}
            </label>
            <h1 className="section-title rleft">{t('ExclusiveNFTS')}</h1>
            <p className="section-description">
              {t('WithThePurchase')}
              <br />
              <span>{t('SingleNFT')}</span> {t('ThatGuaranteesTheAuthenticity')}
              <br />
               <span>{t('MultiplePossibilities')} </span> {t('InTheFuture')}
            </p>
            <a
              target="_blank"
              href="https://opensea.io/assets/matic/0x2953399124f0cbb46d2cbacd8a89cf0599974963/59825812941120029412122519220578683375535007012087703332324853086412284624897"
              className="btn-native-child"
            >
              {t('SeeAtOenSea')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Exclusives;
